import { render, staticRenderFns } from "./CreateRegistration.vue?vue&type=template&id=38c93777"
import script from "./CreateRegistration.vue?vue&type=script&lang=js"
export * from "./CreateRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports